




























































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class TermosDeAceiteFinx extends Vue {
  isModalOpen = false
  pdfUrl = ''

  openModal(): void {
    this.isModalOpen = true
    this.pdfUrl = 'https://finxstsfrontstaticfiles.blob.core.windows.net/politicas-de-privacidade/Pol%C3%ADtica%20de%20Privacidade%20I%20Profissionais%20de%20Sa%C3%BAde.pdf'
  }

  closeModal(): void {
    this.isModalOpen = false
    this.pdfUrl = ''
  }

  handleBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    if (target.classList.contains('modal')) {
      this.closeModal()
    }
  }
}
